import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SubmissionError } from 'redux-form'
import { useHistory } from 'react-router-dom'

import { acceptInvitation } from '../../ducks/users'
import { getInvitation, fetchInvitation } from '../../ducks/invitations'
import Button from '../Shared/Button'
import AuthPage from '../Shared/AuthPage'
import { FullScreenLoader } from '../Shared/Loading'
import FormError from '../Shared/Forms/FormError'
import SignupForm from './SignupForm'

export default function AcceptInvitation({ match }) {
  const { invitationId } = match.params
  const dispatch = useDispatch()
  const history = useHistory()
  const invitation = useSelector(getInvitation(invitationId))

  useEffect(() => {
    dispatch(fetchInvitation(invitationId))
  }, [dispatch, invitationId])

  const handleSignup = async data => {
    try {
      await dispatch(acceptInvitation(invitationId, data))
      history.push('/')
    } catch (err) {
      throw new SubmissionError({
        _error:
          'An unknown error occurred. ' +
          'Please check your information and try again.',
      })
    }
  }

  if (!invitation) {
    return (
      <AuthPage>
        <FullScreenLoader />
      </AuthPage>
    )
  }

  const initialValues = {
    email: invitation.email,
  }

  return (
    <AuthPage
      links={
        <Button text to="/login">
          Already have an account? Login
        </Button>
      }
    >
      {invitation.error ? (
        <FormError>{invitation.error}</FormError>
      ) : (
        <SignupForm
          invitation
          initialValues={initialValues}
          onSubmit={handleSignup}
        />
      )}
    </AuthPage>
  )
}
